import { ReactElement } from 'react'
import { Box } from '@mui/material'
import useUIStore from 'src/state/stores/ui'

/**
 * Where a page's right drawer shows the AI chat while it is open. The chat itself lives in the
 * navbar (its agent keeps running across pages and while the drawer is closed) and is portalled
 * into this box (`portalRootAiChat`). Mounted with the drawer, also while the chat is closed
 * (then hidden): a page offers the chat only through this slot, and the navbar shows the chat
 * button only while one is there.
 */
const AIChatDrawerSlot = (): ReactElement => {
  const setPortalRootAiChat = useUIStore(state => state.setPortalRootAiChat)
  const aiChatOpen = useUIStore(state => state.aiChatOpen)

  return (
    <Box
      ref={setPortalRootAiChat}
      sx={{
        height: '100%',
        minHeight: 0,
        display: aiChatOpen ? 'flex' : 'none',
        flexDirection: 'column',
      }}
      data-cy="ai-chat-drawer"
    />
  )
}

export default AIChatDrawerSlot
